exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"player.styl","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/compact/components/player/player.styl
// module id = 2578
// module chunks = 1